import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ListConfig } from './list.types';
import { Component, OnInit, Input } from '@angular/core';
import { RootComponent } from '../../root/root.component';

@Component({
  selector: 'nw-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent extends RootComponent<ListConfig> implements OnInit {
  elements$: Observable<any[]>;
  loading = true;

  selectedElement: string;
  deletedElement: string;

  addMode = false;
  newEntityName = '';

  ngOnInit(): void {
    if (!this.config) {
      throw new Error('Config must be defined for ListComponent!');
    }
    this.elementType = 'list';
    this.elementInstance = this.config.id;

    // If the store reference is not given the request result is written under the endPoint key
    // this.elements$ = this.http
    //   .get<any[]>(this.config.endpoint, this.config.storeReference)
    //   .pipe(map(response => response.data));

    this.elements$.subscribe(element => {
      if (element) {
        this.loading = false;
        this.deletedElement = null;
      }
    });
  }

  get localConfig() {
    return this.copy(this.config);
  }

  get ref() {
    return this.config.endpoint || this.config.storeReference;
  }

  select(data: any) {
    this.db.storeAction(this.localConfig.select, data);
  }

  private substituteInObject(object, data) {
    Object.entries(object || {}).map(([key, value]) => {
      if (typeof value === 'object') {
        this.substituteInObject(value, data);
      }
      if (value === '${data}') {
        object[key] = data;
      }
    });
    return object;
  }

  add() {
    this.addMode = true;
  }

  create(label: string) {
    const { create } = this.config;
    // this.http.post(
    //   this.ref,
    //   {
    //     literals: { label },
    //   },
    //   create,
    // );
  }

  delete(value: any) {
    if (confirm(`Are you sure you want to delete the ${value.label}`)) {
      this.deletedElement = value.label;
      this.selectedElement = null;
      // this.http.delete(this.ref, value, {
      //   path: this.ref,
      //   deleteKey: value.IRI,
      // });
    }
  }

  cancel() {
    this.addMode = false;
  }

  mouseenter(element: string) {
    if (this.deletedElement) {
      return;
    }
    this.selectedElement = element;
  }

  mouseleave() {
    if (this.deletedElement) {
      return;
    }
    this.selectedElement = null;
  }
}
